// Dependencies.
import Store from '../../store'

const formatRaw = function (number, decimals = 2, thousandSeparator = ' ', decimalSeparator = ',') {
  number = number.toString().replace(/[^\d.-]/g, '')

  // First letter minus sign? Remember that.
  // let numberIsNegative = number[0] === '-';

  // First, make sure we have the actual number set to the correct number of decimals by the JS engine before we
  // format it.
  let numberFloat = parseFloat(number)
  if (isNaN(numberFloat)) {
    return '0'
  }

  // We'll allow providing 'auto' for the decimal value, which will use two decimals if the number is not a whole
  // number, and no decimals otherwise.
  if (decimals === 'auto') {
    decimals = numberFloat % 1 === 0 ? 0 : 2
  }
  number = numberFloat.toFixed(decimals).toString()

  let fraction = ''
  if (number.match(/\./g) !== null) {
    fraction = number.substr(number.indexOf('.') + 1)
    number = number.substr(0, number.indexOf('.'))
  }

  // Reverse it so the digits to the left will be left as single / double digits and not the digits to the right.
  number = number.split('').reverse().join('')

  // Format reversed.
  number = number.replace(/([\d]{3})/g, '$1' + thousandSeparator)

  // Make sure the number doesn't end in a thousand separator.
  if (number[number.length - 1] === thousandSeparator) {
    number = number.substr(0, number.length - 1)
  }

  // Restore reversion and trim...
  number = number.split('').reverse().join('').trim()

  // Avoid a space before a negative sign with three digits, such as '- 100.2'.
  number = number.replace('- ', '-')

  // Restore fraction.
  if (decimals > 0) {
    number += decimalSeparator + fraction.toString()
  }

  return number
}

const format = function (number, decimals = 2, forcedLocale) {
  // Obtain the formatting for the language we've chosen.
  let lang = Store.getters.getCurrLanguage
  if (forcedLocale) {
    lang = {
      iso: forcedLocale
    }
  }
  let thousandSeparator = ','
  let decimalSeparator = '.'

  try {
    let translations = require('../translate/' + lang.iso + '.js')
    if (translations.default) {
      thousandSeparator = translations.default['thousandsSeparator']
      decimalSeparator = translations.default['decimalSeparator']
    }
  } catch (e) {}

  return formatRaw(number, decimals, thousandSeparator, decimalSeparator)
}

export default {
  formatRaw: formatRaw,
  format: format
}



// WEBPACK FOOTER //
// ./src/filters/number/index.js